export const getMultiSelectFilterValues = (e) => {
    let newValues = [];
    if (e.length > 0) {
        for (let i = 0; i < e.length; i++) {
            if (e[i].id !== null && e[i].id !== undefined) {
                newValues.push(e[i].id);
            }
        }
    }
    return newValues;
};

export const getColumnFilterMultiSelectValues = (sourceIds, columnFiltersValues) => {
    let results = [];

    if (!sourceIds || sourceIds.length === 0) return [];

    if (columnFiltersValues && columnFiltersValues.length > 0) {
        for (let i = 0; i < sourceIds.length; i++) {
            const value = columnFiltersValues.find((m) => m.id.toString() === sourceIds[i].toString());
            if (value) {
                results.push(value);
            }
        }
    }

    return results;
};

export function getNullableOnChangeValue(e) {
    // Just for fun, the Dropdown component can return a value that is an object with a 'value' property OR a simple value
    if (e.value && typeof e.value === 'object' && 'value' in e.value) {
        return e.value.value;
    } else {
        return e.value;
    }
}
